import { useEffect, useRef, useState } from "react";
import { Collapse, ListGroup } from "react-bootstrap";
import { usersOnboardingService } from "../../APIServices/usersOnboarding";
import { ImAddressBook } from "react-icons/im";

const StudySidebar = ({ studyId, handleAddNewTab, checkActiveTab, checkActiveDynamicTabData, collapseSidebar }) => {
  const [openForm, setOpenForm] = useState(false);
  const [openSubject, setOpenSubject] = useState(false);
  const [openMedicalReview, setOpenMedicalReview] = useState(false);
  const [openReport, setOpenReport] = useState(false);
  const [openStudy, setOpenStudy] = useState(false);
  const [openQuery, setOpenQuery] = useState(false);
  const [openLab, setOpenLab] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [openSDV, setOpenSDV] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);
  const [openDatasets, setOpenDatasets] = useState(false);
  const [openFormAssign, setOpenFormAssign] = useState(false);
  const [studyLabel, setStudyLabel] = useState("");
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const studyPermission = JSON.parse(localStorage.getItem("studyPermissionData"));

  const findStudyLabel = async () => {
    let data = await usersOnboardingService.findStudyLabel(studyId);
    setStudyLabel(data?.data || "");
  };

  useEffect(() => {
    findStudyLabel();
  }, [studyId]);

  let studyDocumnetAccess = StudyMode === "DBP Mode" || studyPermission?.liveUploadDocument || studyPermission?.liveDownloadDocument || studyPermission?.liveDeleteDocument || studyPermission?.liveSDVUploadDocument || studyPermission?.liveSDVDownloadDocument || studyPermission?.liveSDVDeleteDocument || studyPermission?.qcUploadDocument || studyPermission?.qcDownloadDocument || studyPermission?.qcDeleteDocument || studyPermission?.qcSDVUploadDocument || studyPermission?.qcSDVDownloadDocument || studyPermission?.qcSDVDeleteDocument

  return (
    <div className="sidebar" id="myGroup">
      <div className="menus">
        <ListGroup className="w-100">
          <ListGroup.Item className="border-0 border-bottom text-white rounded-0" style={{ padding: "6px 15px", background: "var(--blue)" }}>
            <div className="hstack justify-content-between w-100">
              <span className="fw-bold hstack" style={{ height: 18 }}>
                <ImAddressBook className="me-1" />
                {!collapseSidebar && studyLabel}
              </span>
            </div>
          </ListGroup.Item>
          <ListGroup className="rounded-0 overflow-auto" style={{ height: "calc(100vh - 144px)" }}>
            <ListGroup.Item action
              className={`border-0 border-bottom ${openStudy && "bg-light"}`}
              style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
              onClick={() => setOpenStudy(!openStudy)}
            >
              <div className="hstack justify-content-between w-100">
                <span>
                  <i className={`fa-solid fa-${openStudy ? "folder-open" : "folder"} me-2`}></i>
                  {!collapseSidebar && <span>Study Management</span>}
                </span>
                <span>
                  <i className={`fa-solid fa-angle-${openStudy ? "down" : "right"}`}></i>
                </span>
              </div>
            </ListGroup.Item>
            <Collapse in={openStudy}>
              <div>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("studyDetail") && "selectedMenu"}`}
                  style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                  onClick={() => { handleAddNewTab("Study Details", "fa-solid fa-circle-info", "studyDetail") }}
                  title={"Study Details"}
                >
                  <i className="fa-solid fa-circle-info me-2" style={{ fontSize: 12 }}></i>
                  {!collapseSidebar && <span>Study Details</span>}
                </ListGroup.Item>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("auditLogs") && "selectedMenu"}`}
                  style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                  onClick={() => { handleAddNewTab("Audit Logs", "fa-solid fa-clipboard-list", "auditLogs") }}
                  title={"Audit Logs"}
                >
                  <i className="fa-solid fa-clipboard-list me-2" style={{ fontSize: 12 }}></i>
                  {!collapseSidebar && <span>Audit Logs</span>}
                </ListGroup.Item>
              </div>
            </Collapse>
            {(StudyMode === "DV Mode" || StudyMode === "DBP Mode") && (
              <>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${openForm && "bg-light"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => setOpenForm(!openForm)}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-${openForm ? "folder-open" : "folder"} me-2`}></i>
                      {!collapseSidebar && <span>Form Management</span>}
                    </span>
                    <span>
                      <i className={`fa-solid fa-angle-${openForm ? "down" : "right"}`}></i>
                    </span>
                  </div>
                </ListGroup.Item>
                <Collapse in={openForm}>
                  <div>
                    {StudyMode === "DBP Mode" && (
                      <>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("formMetadata") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Form Metadata", "fa-solid fa-list-check", "formMetadata") }}
                          title={"Form Metadata"}
                        >
                          <i className="fa-solid fa-list-check me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Form Metadata</span>}
                        </ListGroup.Item>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("editFormFields") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Edit Form Fields", "fa-solid fa-pen-to-square", "editFormFields") }}
                          title={"Edit Form Fields"}
                        >
                          <i className="fa-solid fa-pen-to-square me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Edit Form Fields</span>}
                        </ListGroup.Item>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("manageGlobalFormFieldLibrary") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Form Field Library", "fa-solid fa-book", "manageGlobalFormFieldLibrary") }}
                          title={"Form Field Library"}
                        >
                          <i className="fa-solid fa-book me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Form Field Library</span>}
                        </ListGroup.Item>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("globalFormFieldGroup") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Form Field Group", "fa-solid fa-layer-group", "globalFormFieldGroup") }}
                          title={"Form Field Group"}
                        >
                          <i className="fa-solid fa-layer-group me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Form Field Group</span>}
                        </ListGroup.Item>
                      </>
                    )}
                    {(StudyMode === "DV Mode" || StudyMode === "DBP Mode") && (
                      <>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("viewFormLists") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Form Lists", "fa-solid fa-list", "viewFormLists") }}
                          title={"Form Lists"}
                        >
                          <i className="fa-solid fa-list me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Form Lists</span>}
                        </ListGroup.Item>
                      </>
                    )}
                  </div>
                </Collapse>
              </>
            )}
            {(StudyMode === "DBP Mode") && (
              <>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${openFormAssign && "bg-light"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => setOpenFormAssign(!openFormAssign)}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-${openFormAssign ? "folder-open" : "folder"} me-2`}></i>
                      {!collapseSidebar && <span>Form Assignment</span>}
                    </span>
                    <span>
                      <i className={`fa-solid fa-angle-${openFormAssign ? "down" : "right"}`}></i>
                    </span>
                  </div>
                </ListGroup.Item>
                <Collapse in={openFormAssign}>
                  <div>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("initiateFormAssignment") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Initiate Form", "fa-solid fa-play", "initiateFormAssignment") }}
                      title={"Initiate Form"}
                    >
                      <i className="fa-solid fa-play me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Initiate Form</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("eventFormAssignment") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Event Form", "fa-solid fa-calendar-plus", "eventFormAssignment") }}
                      title={"Event Form"}
                    >
                      <i className="fa-solid fa-calendar-plus me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Event Form</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("unscheduledFormAssignment") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Unscheduled Form", "fa-solid fa-calendar-xmark", "unscheduledFormAssignment") }}
                      title={"Unscheduled Form"}
                    >
                      <i className="fa-solid fa-calendar-xmark me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Unscheduled Form</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("specialFormAssignment") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Special Form", "fa-solid fa-star", "specialFormAssignment") }}
                      title={"Special Form"}
                    >
                      <i className="fa-solid fa-star me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Special Form</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("viewEventSchema") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Event Schema", "fa-solid fa-diagram-project", "viewEventSchema") }}
                      title={"Event Schema"}
                    >
                      <i className="fa-solid fa-diagram-project me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Event Schema</span>}
                    </ListGroup.Item>
                  </div>
                </Collapse>
              </>
            )}
            <ListGroup.Item action
              className={`border-0 border-bottom ${openReport && "bg-light"}`}
              style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
              onClick={() => setOpenReport(!openReport)}
            >
              <div className="hstack justify-content-between w-100">
                <span>
                  <i className={`fa-solid fa-${openReport ? "folder-open" : "folder"} me-2`}></i>
                  {!collapseSidebar && <span>Report Management</span>}
                </span>
                <span>
                  <i className={`fa-solid fa-angle-${openReport ? "down" : "right"}`}></i>
                </span>
              </div>
            </ListGroup.Item>
            <Collapse in={openReport}>
              <div>
                {StudyMode === "DBP Mode" && (
                  <>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("viewFormReportLists") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Form Report", "fa-solid fa-file-lines", "viewFormReportLists") }}
                      title={"Form Report"}
                    >
                      <i className="fa-solid fa-file-lines me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Form Report</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("viewSchemaReportLists") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Schema Report", "fa-solid fa-diagram-project", "viewSchemaReportLists") }}
                      title={"Schema Report"}
                    >
                      <i className="fa-solid fa-diagram-project me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Schema Report</span>}
                    </ListGroup.Item>
                  </>
                )}
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("viewSubjectReportLists") && "selectedMenu"}`}
                  style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                  onClick={() => { handleAddNewTab("Subject Report", "fa-solid fa-user", "viewSubjectReportLists") }}
                  title={"Subject Report"}
                >
                  <i className="fa-solid fa-user me-2" style={{ fontSize: 12 }}></i>
                  {!collapseSidebar && <span>Subject Report</span>}
                </ListGroup.Item>
              </div>
            </Collapse>
            {(StudyMode === "DBP Mode" || StudyMode === "SDV Live Mode" || StudyMode === "SDV QC Mode" || studyPermission?.liveDataEntry || studyPermission?.qcDataEntry || studyPermission?.liveReadOnly || studyPermission?.qcReadOnly) && (
              <ListGroup.Item action
                className={`border-0 border-bottom ${checkActiveTab("dataEntry") && "selectedMenu"}`}
                style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                onClick={() => { handleAddNewTab("Data Management", "fa-solid fa-database", "dataEntry") }}
                title={"Data Management"}
              >
                <div className="hstack justify-content-between w-100">
                  <span>
                    <i className="fa-solid fa-database me-2" style={{ fontSize: 14 }}></i>
                    {!collapseSidebar && <span>Data Management</span>}
                  </span>
                </div>
              </ListGroup.Item>
            )}
            <>
              <ListGroup.Item action
                className={`border-0 border-bottom ${openSubject && "bg-light"}`}
                style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                onClick={() => setOpenSubject(!openSubject)}
              >
                <div className="hstack justify-content-between w-100">
                  <span>
                    <i className={`fa-solid fa-${openSubject ? "folder-open" : "folder"} me-2`}></i>
                    {!collapseSidebar && <span>Subject Management</span>}
                  </span>
                  <span>
                    <i className={`fa-solid fa-angle-${openSubject ? "down" : "right"}`}></i>
                  </span>
                </div>
              </ListGroup.Item>
              <Collapse in={openSubject}>
                <div>
                  <ListGroup.Item action
                    className={`border-0 border-bottom ${checkActiveTab("randomizedKitSubject") && "selectedMenu"}`}
                    style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                    onClick={() => { handleAddNewTab("Randomized Subjects", "fa-solid fa-circle-check", "randomizedKitSubject") }}
                    title={"Randomized Subjects"}
                  >
                    <i className="fa-solid fa-circle-check me-2" style={{ fontSize: 12 }}></i>
                    {!collapseSidebar && <span>Randomized Subjects</span>}
                  </ListGroup.Item>
                  <ListGroup.Item action
                    className={`border-0 border-bottom ${checkActiveTab("subjectStatus") && "selectedMenu"}`}
                    style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                    onClick={() => { handleAddNewTab("Subject Status", "fa-solid fa-circle-check", "subjectStatus") }}
                    title={"Subject Status"}
                  >
                    <i className="fa-solid fa-circle-check me-2" style={{ fontSize: 12 }}></i>
                    {!collapseSidebar && <span>Subject Status</span>}
                  </ListGroup.Item>
                  <ListGroup.Item action
                    className={`border-0 border-bottom ${checkActiveTab("subjectEventStatus") && "selectedMenu"}`}
                    style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                    onClick={() => { handleAddNewTab("Subject Event Status", "fa-solid fa-calendar-check", "subjectEventStatus") }}
                    title={"Subject Event Status"}
                  >
                    <i className="fa-solid fa-calendar-check me-2" style={{ fontSize: 12 }}></i>
                    {!collapseSidebar && <span>Subject Event Status</span>}
                  </ListGroup.Item>
                  <ListGroup.Item action
                    className={`border-0 border-bottom ${checkActiveTab("screenFailedHistory") && "selectedMenu"}`}
                    style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                    onClick={() => { handleAddNewTab("Subject Screen Failed Status", "fa-solid fa-circle-xmark", "screenFailedHistory") }}
                    title={"Subject Screen Failed Status"}
                  >
                    <i className="fa-solid fa-circle-xmark me-2" style={{ fontSize: 12 }}></i>
                    {!collapseSidebar && <span>Screen Failed Status</span>}
                  </ListGroup.Item>
                  <ListGroup.Item action
                    className={`border-0 border-bottom ${checkActiveTab("subjectDiscontinueHistory") && "selectedMenu"}`}
                    style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                    onClick={() => { handleAddNewTab("Subject Discontinue Status", "fa-solid fa-circle-exclamation", "subjectDiscontinueHistory") }}
                    title={"Subject Discontinue Status"}
                  >
                    <i className="fa-solid fa-circle-exclamation me-2" style={{ fontSize: 12 }}></i>
                    {!collapseSidebar && <span>Discontinue Status</span>}
                  </ListGroup.Item>
                </div>
              </Collapse>
            </>
            <>
              <ListGroup.Item action
                className={`border-0 border-bottom ${openMedicalReview && "bg-light"}`}
                style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                onClick={() => setOpenMedicalReview(!openMedicalReview)}
              >
                <div className="hstack justify-content-between w-100">
                  <span>
                    <i className={`fa-solid fa-${openMedicalReview ? "folder-open" : "folder"} me-2`}></i>
                    {!collapseSidebar && <span>Medical Review</span>}
                  </span>
                  <span>
                    <i className={`fa-solid fa-angle-${openMedicalReview ? "down" : "right"}`}></i>
                  </span>
                </div>
              </ListGroup.Item>
              <Collapse in={openMedicalReview}>
                <div>
                  {StudyMode === "DBP Mode" ? (
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("medicalReviewSettings") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Medical Review Settings", "fa-solid fa-gear", "medicalReviewSettings") }}
                      title={"Medical Review Settings"}
                    >
                      <i className="fa-solid fa-gear me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Review Settings</span>}
                    </ListGroup.Item>
                  ) :
                    <>
                      <ListGroup.Item action
                        className={`border-0 border-bottom ${checkActiveTab("medicalReviewTask") && "selectedMenu"}`}
                        style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                        onClick={() => { handleAddNewTab("Medical Review Task Management", "fa-solid fa-tasks", "medicalReviewTask") }}
                        title={"Task Management"}
                      >
                        <i className="fa-solid fa-tasks me-2" style={{ fontSize: 12 }}></i>
                        {!collapseSidebar && <span>Task Management</span>}
                      </ListGroup.Item>
                      <ListGroup.Item action
                        className={`border-0 border-bottom ${checkActiveTab("medicalReviewSummery") && "selectedMenu"}`}
                        style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                        onClick={() => { handleAddNewTab("Medical Review Task Summery", "fa-solid fa-chart-pie", "medicalReviewSummery") }}
                        title={"Summery"}
                      >
                        <i className="fa-solid fa-chart-pie me-2" style={{ fontSize: 12 }}></i>
                        {!collapseSidebar && <span>Review Summery</span>}
                      </ListGroup.Item>
                      <ListGroup.Item action
                        className={`border-0 border-bottom ${checkActiveTab("MedicalBulkReview") && "selectedMenu"}`}
                        style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                        onClick={() => { handleAddNewTab("Medical Bulk Review", "fa-solid fa-layer-group", "MedicalBulkReview") }}
                        title={"Summery"}
                      >
                        <i className="fa-solid fa-layer-group me-2" style={{ fontSize: 12 }}></i>
                        {!collapseSidebar && <span>Bulk Review</span>}
                      </ListGroup.Item>
                    </>
                  }
                </div>
              </Collapse>
            </>
            {(StudyMode === "DBP Mode" || (studyPermission?.liveDatasets || studyPermission?.qcDatasets || studyPermission?.liveSDVDatasets || studyPermission?.qcSDVDatasets || studyPermission?.liveDataTransferJob || studyPermission?.liveSDVDataTransferJob || studyPermission?.qcDataTransferJob || studyPermission?.qcSDVDataTransferJob)) && (
              <>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${openDatasets && "bg-light"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => setOpenDatasets(!openDatasets)}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-${openDatasets ? "folder-open" : "folder"} me-2`}></i>
                      {!collapseSidebar && <span>Datasets Management</span>}
                    </span>
                    <span>
                      <i className={`fa-solid fa-angle-${openDatasets ? "down" : "right"}`}></i>
                    </span>
                  </div>
                </ListGroup.Item>
                <Collapse in={openDatasets}>
                  <div>
                    {(StudyMode === "DBP Mode" || (studyPermission?.liveDatasets || studyPermission?.qcDatasets || studyPermission?.liveSDVDatasets || studyPermission?.qcSDVDatasets)) &&
                      <>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("datasets") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Dataset By Column", "fa-solid fa-table-columns", "datasets") }}
                          title={"Dataset By Column"}
                        >
                          <i className="fa-solid fa-table-columns me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Dataset By Column</span>}
                        </ListGroup.Item>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("datasetsByRow") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Dataset By Row", "fa-solid fa-table-list", "datasetsByRow") }}
                          title={"Dataset By Row"}
                        >
                          <i className="fa-solid fa-table-list me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Dataset By Row</span>}
                        </ListGroup.Item>
                      </>
                    }
                    {(StudyMode === "DBP Mode" || (studyPermission?.liveDataTransferJob || studyPermission?.liveSDVDataTransferJob || studyPermission?.qcDataTransferJob || studyPermission?.qcSDVDataTransferJob)) &&
                      <>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("transferedDatasetList") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Transfered Datasets", "fa-solid fa-arrow-right-arrow-left", "transferedDatasetList") }}
                          title={"Transfered Datasets"}
                        >
                          <i className="fa-solid fa-arrow-right-arrow-left me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Transfered Datasets</span>}
                        </ListGroup.Item>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("onDemandDatasets") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Ondemand Datasets", "fa-solid fa-cloud-arrow-down", "onDemandDatasets") }}
                          title={"Ondemand Datasets"}
                        >
                          <i className="fa-solid fa-cloud-arrow-down me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Ondemand Datasets</span>}
                        </ListGroup.Item>
                      </>
                    }
                  </div>
                </Collapse>
              </>
            )}
            {StudyMode !== "DV Mode" && (
              <>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${openQuery && "bg-light"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => setOpenQuery(!openQuery)}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-${openQuery ? "folder-open" : "folder"} me-2`}></i>
                      {!collapseSidebar && <span>Query Management</span>}
                    </span>
                    <span>
                      <i className={`fa-solid fa-angle-${openQuery ? "down" : "right"}`}></i>
                    </span>
                  </div>
                </ListGroup.Item>
                <Collapse in={openQuery}>
                  <div>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("queryOverview") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Query Overview", "fa-solid fa-magnifying-glass-chart", "queryOverview") }}
                      title={"Query Overview"}
                    >
                      <i className="fa-solid fa-magnifying-glass-chart me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Query Overview</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("manageQuery") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Manage Query", "fa-solid fa-message", "manageQuery") }}
                      title={"Manage Query"}
                    >
                      <i className="fa-solid fa-message me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Manage Query</span>}
                    </ListGroup.Item>
                    {StudyMode === "DBP Mode" &&
                      <ListGroup.Item action
                        className={`border-0 border-bottom ${checkActiveTab("queryStatistics") && "selectedMenu"}`}
                        style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                        onClick={() => { handleAddNewTab("Query Statistics", "fa-solid fa-chart-bar", "queryStatistics") }}
                        title={"Query Statistics"}
                      >
                        <i className="fa-solid fa-chart-bar me-2" style={{ fontSize: 12 }}></i>
                        {!collapseSidebar && <span>Query Statistics</span>}
                      </ListGroup.Item>
                    }
                  </div>
                </Collapse>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${openNotification && "bg-light"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => setOpenNotification(!openNotification)}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-${openNotification ? "folder-open" : "folder"} me-2`}></i>
                      {!collapseSidebar && <span>Notification Management</span>}
                    </span>
                    <span>
                      <i className={`fa-solid fa-angle-${openNotification ? "down" : "right"}`}></i>
                    </span>
                  </div>
                </ListGroup.Item>
                <Collapse in={openNotification}>
                  <div>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("notificationOverview") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Notification Overview", "fa-solid fa-bell", "notificationOverview") }}
                      title={"Notification Overview"}
                    >
                      <i className="fa-solid fa-bell me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Notification Overview</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("manageNotification") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Manage Notification", "fa-solid fa-envelope", "manageNotification") }}
                      title={"Manage Notification"}
                    >
                      <i className="fa-solid fa-envelope me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Manage Notification</span>}
                    </ListGroup.Item>
                    {StudyMode === "DBP Mode" &&
                      <ListGroup.Item action
                        className={`border-0 border-bottom ${checkActiveTab("notificationStatistics") && "selectedMenu"}`}
                        style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                        onClick={() => { handleAddNewTab("Notification Statistics", "fa-solid fa-chart-simple", "notificationStatistics") }}
                        title={"Notification Statistics"}
                      >
                        <i className="fa-solid fa-chart-simple me-2" style={{ fontSize: 12 }}></i>
                        {!collapseSidebar && <span>Notification Statistics</span>}
                      </ListGroup.Item>
                    }
                  </div>
                </Collapse>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${openSDV && "bg-light"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => setOpenSDV(!openSDV)}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-${openSDV ? "folder-open" : "folder"} me-2`}></i>
                      {!collapseSidebar && <span>SDV Management</span>}
                    </span>
                    <span>
                      <i className={`fa-solid fa-angle-${openSDV ? "down" : "right"}`}></i>
                    </span>
                  </div>
                </ListGroup.Item>
                <Collapse in={openSDV}>
                  <div>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("formSDV") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Form SDV", "fa-solid fa-clipboard-check", "formSDV") }}
                      title={"Form SDV"}
                    >
                      <i className="fa-solid fa-clipboard-check me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Form SDV</span>}
                    </ListGroup.Item>
                    {StudyMode === "DBP Mode" &&
                      <ListGroup.Item action
                        className={`border-0 border-bottom ${checkActiveTab("SDVStatistics") && "selectedMenu"}`}
                        style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                        onClick={() => { handleAddNewTab("SDV Statistics", "fa-solid fa-chart-line", "SDVStatistics") }}
                        title={"SDV Statistics"}
                      >
                        <i className="fa-solid fa-chart-line me-2" style={{ fontSize: 12 }}></i>
                        {!collapseSidebar && <span>SDV Statistics</span>}
                      </ListGroup.Item>
                    }
                  </div>
                </Collapse>
              </>
            )}
            {(StudyMode === "DBP Mode" || studyPermission?.liveLabRangeSettings || studyPermission?.qcLabRangeSettings) &&
              <ListGroup.Item action
                className={`border-0 border-bottom ${checkActiveTab("labRangeSettings") && "selectedMenu"}`}
                style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                onClick={() => { handleAddNewTab("Lab Range Settings", "fa-solid fa-flask", "labRangeSettings") }}
                title={"Lab Range Settings"}
              >
                <i className="fa-solid fa-flask me-2" style={{ fontSize: 12 }}></i>
                {!collapseSidebar && <span>Lab Range Settings</span>}
              </ListGroup.Item>
            }
            {StudyMode === "DBP Mode" && (
              <>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${openSettings && "bg-light"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => setOpenSettings(!openSettings)}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-${openSettings ? "folder-open" : "folder"} me-2`}></i>
                      {!collapseSidebar && <span>Study Settings</span>}
                    </span>
                    <span>
                      <i className={`fa-solid fa-angle-${openSettings ? "down" : "right"}`}></i>
                    </span>
                  </div>
                </ListGroup.Item>
                <Collapse in={openSettings}>
                  <div>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("autoQueryChecks") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Auto Query Checks", "fa-solid fa-bolt", "autoQueryChecks") }}
                      title={"Auto Query Checks"}
                    >
                      <i className="fa-solid fa-bolt me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Auto Query Checks</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("notificationChecks") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Notification Checks", "fa-solid fa-check-circle", "notificationChecks") }}
                      title={"Notification Checks"}
                    >
                      <i className="fa-solid fa-check-circle me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Notification Checks</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("inclusionExclusionChecks") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Inclusion/Exclusion Checks", "fa-solid fa-list-check", "inclusionExclusionChecks") }}
                      title={"Inclusion/Exclusion Checks"}
                    >
                      <i className="fa-solid fa-list-check me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Inclusion/Exclusion Checks</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("fieldNotificationMail") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Field Notification Mail", "fa-solid fa-envelope-open", "fieldNotificationMail") }}
                      title={"Field Notification Mail"}
                    >
                      <i className="fa-solid fa-envelope-open me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Field Notification Mail</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("derivedVariable") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Derived Variable", "fa-solid fa-calculator", "derivedVariable") }}
                      title={"Derived Variable"}
                    >
                      <i className="fa-solid fa-calculator me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Derived Variable</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("assignField") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Assign Field", "fa-solid fa-link", "assignField") }}
                      title={"Assign Field"}
                    >
                      <i className="fa-solid fa-link me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Assign Field</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("assignGender") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Assign Gender", "fa-solid fa-venus-mars", "assignGender") }}
                      title={"Assign Gender"}
                    >
                      <i className="fa-solid fa-venus-mars me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Assign Gender</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("reportMetadata") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Report Metadata", "fa-solid fa-table", "reportMetadata") }}
                      title={"Report Metadata"}
                    >
                      <i className="fa-solid fa-table me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Report Metadata</span>}
                    </ListGroup.Item>
                  </div>
                </Collapse>
              </>
            )}
            {studyDocumnetAccess && (
              <ListGroup.Item action
                className={`border-0 border-bottom ${checkActiveTab("studyDocument") && "selectedMenu"}`}
                style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                onClick={() => { handleAddNewTab("Study Document", "fa-solid fa-file-pdf", "studyDocument") }}
                title={"Study Document"}
              >
                <i className="fa-solid fa-file-pdf me-2" style={{ fontSize: 12 }}></i>
                {!collapseSidebar && <span>Study Document</span>}
              </ListGroup.Item>
            )}
            {(studyPermission?.livePrincipleInvestigator || studyPermission?.qcPrincipleInvestigator || studyPermission?.liveSDVPrincipleInvestigator || studyPermission?.qcSDVPrincipleInvestigator) &&
              <ListGroup.Item action
                className={`border-0 border-bottom ${checkActiveTab("principleInvestigatorSignature") && "selectedMenu"}`}
                style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                onClick={() => { handleAddNewTab("PI Signature", "fa-solid fa-pen", "principleInvestigatorSignature") }}
                title={"PI Signature"}
              >
                <i className="fa-solid fa-pen me-2" style={{ fontSize: 12 }}></i>
                {!collapseSidebar && <span>PI Signature</span>}
              </ListGroup.Item>
            }
            {(StudyMode === "QC Mode" || StudyMode === "DBP Mode") &&
              <ListGroup.Item action
                className={`border-0 border-bottom ${openLab && "bg-light"}`}
                style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                onClick={() => setOpenLab(!openLab)}
              >
                <div className="hstack justify-content-between w-100">
                  <span>
                    <i className={`fa-solid fa-${openLab ? "folder-open" : "folder"} me-2`}></i>
                    {!collapseSidebar && <span>Galax Data Integration Engine</span>}
                  </span>
                  <span>
                    <i className={`fa-solid fa-angle-${openLab ? "down" : "right"}`}></i>
                  </span>
                </div>
              </ListGroup.Item>
            }
            <Collapse in={openLab}>
              <div>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("uploadLabData") && "selectedMenu"}`}
                  style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                  onClick={() => { handleAddNewTab("Upload Galax Data", "fa-solid fa-upload", "uploadLabData") }}
                  title={"Upload Galax Data"}
                >
                  <i className="fa-solid fa-upload me-2" style={{ fontSize: 12 }}></i>
                  {!collapseSidebar && <span>Upload Galax Data</span>}
                </ListGroup.Item>

                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("mapper") && "selectedMenu"}`}
                  style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                  onClick={() => { handleAddNewTab("Mapper", "fa-solid fa-diagram-project", "mapper") }}
                  title={"Mapper"}
                >
                  <i className="fa-solid fa-diagram-project me-2" style={{ fontSize: 12 }}></i>
                  {!collapseSidebar && <span>Mapper</span>}
                </ListGroup.Item>
              </div>
            </Collapse>
          </ListGroup>
        </ListGroup>
      </div>
    </div>
  );
};

export default StudySidebar;